/* eslint react/no-array-index-key: off */
import React, {Fragment} from 'react';

const Legal = ({legal}) => {
    if (!legal || !legal.length) {
        return null;
    }

    return (
        <div>
            {legal.map((legalSection, sectionIndex) => (
                <Fragment key={`section-${sectionIndex}`}>
                    <h3>{legalSection.title}</h3>
                    {legalSection.text.map((paragraph, paragraphIndex) =>
                        <p key={`paragraph-${paragraphIndex}`}>{paragraph}</p>
                    )}
                </Fragment>
            ))}
        </div>
    );
};

export default Legal;



// WEBPACK FOOTER //
// ./src/event/Legal.js